import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { Purchase, PurchaseListParams } from '~/features/purchase/types/purchase.type';

/**
 * 구매 목록 조회
 * @description 구매 내역 목록을 조회합니다
 * @endpoint GET /admin/purchases
 * @param params - 조회 파라미터
 * @returns 구매 목록 및 페이지네이션 정보
 */
export function getPurchaseListApi(params?: PurchaseListParams) {
  return axiosInstance.get<PaginatedApiResponse<Purchase>>('/admin/purchases', { params });
}
